import React from 'react';

const ChangeLanguageWidget = (props) => {
    const {currentLanguage: language, changeLanguage} = props;

    return (
        <div className='language-select-container'>
            <div className='col-12'>
                <select className='language-select' onChange={changeLanguage}>
                    <option value='fi' selected={language === 'fi'}>
                        Suomi
                    </option>
                    <option value='en' selected={language === 'en'}>
                        English
                    </option>
                    <option value='se' selected={language === 'se'}>
                        Sverige
                    </option>
                </select>
            </div>
        </div>
    );
}

export default ChangeLanguageWidget;



// WEBPACK FOOTER //
// ./src/components/ChangeLanguageWidget.js